import React, { useState, useEffect, useRef } from "react";
import logo from '../Assets/images/logo-green.svg';
import call from '../Assets/images/call.png';

const Header = ({ isScrolled }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
      <header className={`header-wrapper d-flex justify-between align-center ${isScrolled ? "scrolled" : ""}`}> 
        <div className='logo-wrapper'>
          <img src={logo} alt="Merch On Chain Logo" />
        </div>

        {/* Desktop CTA */}
        <div className='cta-wrapper d-flex desktop-only'>
          <a 
            href="https://docsend.com/v/sgjk8/merchonchain1" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary mr-2"
          >
            VIEW CATALOGUE
          </a>
          <div className="dropdown-wrap">
            <button className='btn btn-secondary'>TALK TO US</button>
            <div className="dropdown">
              <div className="d-flex align-center text-cont">  
                <p className="m-0"> Reach out in the way that suits you</p>
                <div><img src={call} alt="call" /></div>
              </div>
              <div>
                <a href="https://t.me/merchonchain" target="_blank" rel="noopener noreferrer" className='ml-2'>
                  Chat with us
                </a>
              </div> 
              <div>
                <a href="https://t.me/merchonchain" target="_blank" rel="noopener noreferrer" className='ml-2'>
                  Book a call
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Hamburger icon */}
        <div className={`hamburger mobile-only`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      {/* Mobile Menu Panel */}
      <div ref={menuRef} className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="close-icon" onClick={closeMenu}>✕</div>

        <a 
          href="https://docsend.com/v/sgjk8/merchonchain1" 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn btn-primary"
          onClick={closeMenu}
        >
          VIEW CATALOGUE
        </a>

        <div className="dropdown-wrap mt-3">
          <button className='btn btn-secondary'>TALK TO US</button>
          <div className="dropdown">
            <div className="d-flex align-center text-cont">  
              <p className="m-0"> Reach out in the way that suits you</p>
              <div><img src={call} alt="call" /></div>
            </div>
            <div>
              <a href="https://t.me/merchonchain" target="_blank" rel="noopener noreferrer" className='ml-2' onClick={closeMenu}>
                Chat with us
              </a>
            </div> 
            <div>
              <a href="https://t.me/merchonchain" target="_blank" rel="noopener noreferrer" className='ml-2' onClick={closeMenu}>
                Book a call
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
